import Column from "@components/column";
import React from "react";
import OrderSetting from "./order-setting";
import StoreSetting from "./store-setting";

const Order = () => {
  return (
    <Column>
      <OrderSetting />
      <StoreSetting />
    </Column>
  );
};

export default Order;
